import arriving from './arriving';
import boxing from './boxing';
import cartonCounting from './carton-counting';
import counting from './counting';
import qc from './qc';
import receiving from './receiving';

export default [
  ...qc,
  ...boxing,
  ...cartonCounting,
  ...arriving,
  ...counting,
  ...receiving,
];
